<template>
  <div class="publicMain">
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="服务产品">
          <el-input v-model="form.serviceProducts"></el-input>
        </el-form-item>
        <el-form-item label="服务类型">
          <el-select v-model="form.serviceType" placeholder="请选择活动区域">
            <el-option label="生活照料" value="0"></el-option>
            <el-option label="医疗保健" value="1"></el-option>
            <el-option label="家政服务" value="2"></el-option>
            <el-option label="紧急救助" value="3"></el-option>
            <el-option label="精神慰藉" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="add">新增</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" style="display:flex;justify-content: center;">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip
                class="item"
                style="color:#dd3020;"
                effect="light"
                content="删除"
                placement="top-start"
              >
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div v-else-if="item.type=='cost'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.cost==0">收费</el-tag>
                <el-tag v-if="scope.row.cost==1" type="success">免费</el-tag>
              </div>
            </div>
            <div v-else-if="item.type=='serviceType'">
              <div style="text-align:center;">
                <span v-if="scope.row.serviceType==0" type="success">生活照料</span>
                <span v-else-if="scope.row.serviceType==1" type="primary">医疗保健</span>
                <span v-else-if="scope.row.serviceType==2" type="primary">家政服务</span>
                <span v-else-if="scope.row.serviceType==3" type="primary">紧急救助</span>
                <span v-else-if="scope.row.serviceType==4" type="primary">精神慰藉</span>
              </div>
            </div>
            <div v-else-if="item.type=='region'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.region==0" type="success">次</el-tag>
                <el-tag v-else-if="scope.row.region==1" type="warning">小时</el-tag>
                <el-tag v-else-if="scope.row.region==2" type="danger">月</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="40%">
      <div style="width:100%; width: 90%;margin: 0px auto;">
        <el-form
          v-if="visible"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="服务类型" prop="serviceType">
            <el-select v-model="ruleForm.serviceType" placeholder="请选择活动区域">
              <el-option label="生活照料" value="0"></el-option>
              <el-option label="医疗保健" value="1"></el-option>
              <el-option label="家政服务" value="2"></el-option>
              <el-option label="紧急救助" value="3"></el-option>
              <el-option label="精神慰藉" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务产品" prop="serviceProducts">
            <el-input v-model="ruleForm.serviceProducts"></el-input>
          </el-form-item>
          <el-form-item label="费用" prop="cost">
            <el-select v-model="ruleForm.cost" >
              <el-option label="收费" value="0"></el-option>
              <el-option label="免费" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收费标准" required v-if="ruleForm.cost==0">
            <el-col :span="11">
              <el-form-item prop="charge">
                <el-input  v-model="ruleForm.charge">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="2" style="height:1px"></el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-select v-model="ruleForm.region" >
                  <el-option label="次" :value="0"></el-option>
                  <el-option label="小时" :value="1"></el-option>
                  <el-option label="月" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="说明" prop="explains">
            <el-input type="textarea" v-model="ruleForm.explains"></el-input>
          </el-form-item>

          <div class="button" v-if="title!='查看'">
            <div class="button-mid" >
              <el-button type="primary" @click="save">确定</el-button>
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
          </div>
          <div class="button" v-else>
            <div class="button-mid" style="justify-content: center">
              <el-button type="info" @click="visible=false">取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    communityServeProductEdit,
    communityServeProductCheck,
    communityServeProductList,
    communityServeProductDelete, communityActiveEdit, communityActiveCheck,

  } from "../api";
//救助管理
import request from "@/utils/request.js";

import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {

    upload
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {},
      fileList: [],
      typeImg: "",
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "serviceType",
          type: "serviceType",
          label: "服务类型"
        },
        {
          prop: "serviceProducts",
          label: "服务产品"
        },
        {
          prop: "cost",
          type: "cost",
          label: "费用"
        },
        {
          prop: "charge",
          label: "收费标准(元)"
        },

        {
          label: "操作",
          type: "button"
        }
      ],
      rules: {
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "blur" },
        ],
        serviceProducts: [
          { required: true, message: "请输入服务产品", trigger: "blur" },
        ],
        cost: [
          { required: true, message: "请选择费用", trigger: "blur" },
        ],
        charge: [
          { required: true, message: "请输入收费标准", trigger: "blur" },
        ],
        regions: [
          { required: true, message: "请选择单位", trigger: "blur" },
        ],
      },

      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      ruleForm: {},
      rulesDialog: {}
    };
  },
  methods: {
    //查询
    onCheck() {
      this.getListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form
      });
      this.$message({
        message: "查询成功",
        type: "success"
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.getListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      this.$message({
        message: "重置成功",
        type: "success"
      });
    },
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到列表
    getListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        mechanismId:this.id
      });
      communityServeProductList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.title = "新增";
      this.ruleForm = {};
      try {
        this.$refs.ruleForm.clearValidate()
      } catch (error) {

      }
    },
    check(e) {
      this.visible = true;
      this.title = "查看";
      this.getData({id:e.id})
    },
    //编辑
    compile(e) {
      this.visible = true;
      this.title = "编辑";
      this.getData({id:e.id})
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          communityServeProductDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //保存按钮
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.ruleForm = Object.assign({}, this.ruleForm, {
            mechanismId:this.id
          });
          communityServeProductEdit(this.ruleForm).then((res) => {
            this.$message({
              type: "success",
              message: this.ruleForm.id ? "编辑成功" : "新增成功",
            });
            this.visible = false
            this.getListAPI()
          });
        }
      });
    },
    //回写拿到数据
    getData(e) {
      communityServeProductCheck(e).then((res) => {
        this.ruleForm = res.content;
      });
    },
  },
  created() {
    this.getListAPI({
      pageNo: 1,
      pageSize: 10
    });
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-radio {
  margin: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
</style>
